/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Prospects_Icgpriority2Inputs */

const en_coinvestments_prospects_icgpriority2 = /** @type {(inputs: Coinvestments_Prospects_Icgpriority2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ICG Priority`)
};

/**
* | output |
* | --- |
* | "ICG Priority" |
*
* @param {Coinvestments_Prospects_Icgpriority2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_prospects_icgpriority2 = /** @type {((inputs?: Coinvestments_Prospects_Icgpriority2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Prospects_Icgpriority2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_prospects_icgpriority2(inputs)
});
export { coinvestments_prospects_icgpriority2 as "coInvestments_prospects_icgPriority" }